module.exports = __webpack_public_path__ + "img/authbg.be27474c.svg";